"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSearchPreviewData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _featureToggles = require("@ori/feature-toggles");
var _fetching = require("@ori/fetching");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _api = require("../api");
var _constants = require("../constants");
var _utils = require("../utils");
const useGetSearchPreviewData = ({
  query
}) => {
  const logger = (0, _logger.useLogger)('useGetSearchPreviewData');
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    headers
  } = (0, _presentationHttp.useHeaders)();
  const [timestamp, setTimestamp] = (0, _react.useState)(0);
  const {
    data,
    isLoading,
    mutate
  } = (0, _fetching.useSWR)(query ? ['search-preview-data', graphQlNetUrl, headers, query] : null, async () => {
    const response = await (0, _api.getSearchPreviewData)({
      graphQlNetUrl,
      headers,
      query,
      limit: _constants.SEARCH_PREVIEW_PRODUCTS_LIMIT
    });
    setTimestamp(Date.now());
    return (0, _utils.mapSearchPreviewQuery)({
      personalSubscriptionsEnabled: isFeatureEnabled(_constants.TopAreaFeature.PersonalSubscriptions),
      query: response
    });
  }, {
    ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
    onError: error => logger.error(new Error('Failed to fetch search preview data', {
      cause: error
    }))
  });
  const clearResults = (0, _react.useCallback)(async () => mutate(undefined, false), [mutate]);
  return {
    data,
    isLoading,
    timestamp,
    clearResults
  };
};
exports.useGetSearchPreviewData = useGetSearchPreviewData;
